import { Frown, Meh, SmilePlus, Smile, SmileIcon } from "lucide-react";

export const EMOJI_SETS = {
  4: [
    {
      Icon: Frown,
      color: "#FF4D4F",
      symbol: "😞",
    },
    {
      Icon: Meh,
      color: "#FFA940",
      symbol: "😐",
    },
    {
      Icon: Smile,
      color: "#52C41A",
      symbol: "😊",
    },
    {
      Icon: SmilePlus,
      color: "#1890FF",
      symbol: "😄",
    },
  ],
  5: [
    {
      Icon: Frown,
      color: "#FF4D4F",
      symbol: "😞",
    },
    {
      Icon: Meh,
      color: "#FFA940",
      symbol: "😐",
    },
    {
      Icon: SmileIcon,
      color: "#FADB14",
      symbol: "🙂",
    },
    {
      Icon: Smile,
      color: "#52C41A",
      symbol: "😊",
    },
    {
      Icon: SmilePlus,
      color: "#1890FF",
      symbol: "😄",
    },
  ],
  7: [
    {
      Icon: Frown,
      color: "#FF4D4F",
      symbol: "😞",
    },
    {
      Icon: Frown,
      color: "#FF7A45",
      symbol: "😕",
    },
    {
      Icon: Meh,
      color: "#FFA940",
      symbol: "😐",
    },
    {
      Icon: SmileIcon,
      color: "#FADB14",
      symbol: "🙂",
    },
    {
      Icon: Smile,
      color: "#73D13D",
      symbol: "😊",
    },
    {
      Icon: Smile,
      color: "#52C41A",
      symbol: "😄",
    },
    {
      Icon: SmilePlus,
      color: "#1890FF",
      symbol: "😁",
    },
  ],
};

export const USER_AVATAR_BACKGROUNDS = [
  "linear-gradient(135deg, #a78bfa, #7c3aed)",
  "linear-gradient(135deg, #60a5fa, #2563eb)",
  "linear-gradient(135deg, #34d399, #059669)",
  "linear-gradient(135deg, #fbbf24, #d97706)",
  "linear-gradient(135deg, #fb7185, #e11d48)",
  "linear-gradient(135deg, #22d3ee, #0891b2)",
  "linear-gradient(135deg, #e879f9, #c026d3)",
  "linear-gradient(135deg, #fb923c, #ea580c)",
  "linear-gradient(135deg, #818cf8, #4f46e5)",
  "linear-gradient(135deg, #2dd4bf, #0f766e)",
];


export const DEFAULT_EMOJI_DESCRIPTIONS = {
  4: ["Poor", "Fair", "Good", "Excellent"],
  5: [
    "Very Unsatisfied",
    "Unsatisfied",
    "Neutral",
    "Satisfied",
    "Very Satisfied",
  ],
  7: [
    "Extremely Poor",
    "Very Poor",
    "Poor",
    "Neutral",
    "Good",
    "Very Good",
    "Excellent",
  ],
};